import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {
    fetchDestinationUrgencyMessage
} from '../../../actions/urgency-message';

class UrgencyMessagesLoaderComponent extends Component {
    static propTypes = {
        lbsId: PropTypes.string
    };

    componentDidMount() {
        this.props.dispatch(fetchDestinationUrgencyMessage(this.props.lbsId));
    }

    render = () => <span />;
}

export const UrgencyMessagesLoader = connect((s) => ({
    lbsId: s.destination.details.lbsId
}))(UrgencyMessagesLoaderComponent);
